// Centralisation de l'URL de base API
// Utilise REACT_APP_API_URL (ex: http://localhost:55000/api) sinon chemin relatif /api
const RAW = process.env.REACT_APP_API_URL || '/api';
export const API_BASE = RAW.replace(/\/$/, '');

// URL de base pour le backend (sans /api)
export const BACKEND_URL = API_BASE.replace(/\/api$/, '');

// Helper pour construire des URLs complètes
export const buildApiUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${cleanPath}`;
};

// Helper pour construire des URLs backend (non-API)
export const buildBackendUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_URL}${cleanPath}`;
};

export default API_BASE;
